export default "__VITE_ASSET__7xzOI2WH__"